import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Navigate } from "react-router-dom";
import { shallow } from "zustand/shallow";
import Breadcrumb from "../../components/Breadcrumb";
import { Role, useAuthStore } from "../../stores/auth";
import ArticleImportTab from "./ArticleImportTab";

const TABS = [
  {
    key: "articles",
    labelKey: "settings.imports.tabs.articles",
    Component: ArticleImportTab,
  },
  // Add additional import sources here, e.g.
  // { key: "customers", labelKey: "settings.imports.tabs.customers", Component: CustomerImportTab },
];

function ImportSettings() {
  const { t } = useTranslation();
  const [hasRole] = useAuthStore((s) => [s.hasRole], shallow);
  const [activeTab, setActiveTab] = useState(TABS[0].key);

  if (!hasRole(Role.ADMINISTRATOR)) {
    return <Navigate to="/" replace />;
  }

  const active = TABS.find((tab) => tab.key === activeTab) ?? TABS[0];
  const ActiveComponent = active.Component;

  return (
    <>
      <Breadcrumb
        items={[
          { label: t("menu.settings"), to: "/settings" },
          { label: t("settings.imports.title") },
        ]}
      />
      <div className="card">
        <ul className="nav nav-tabs nav-tabs-v2 px-3">
          {TABS.map((tab) => (
            <li key={tab.key} className="nav-item me-2">
              <button
                type="button"
                className={`nav-link px-2 ${activeTab === tab.key ? "active" : ""}`}
                onClick={() => setActiveTab(tab.key)}
              >
                {t(tab.labelKey)}
              </button>
            </li>
          ))}
        </ul>
        <div className="tab-content p-3">
          <ActiveComponent />
        </div>
      </div>
    </>
  );
}

export default ImportSettings;
